<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12 p-lg-3 p-mb-4">
    <p-card class="fonte-dados-filtros" header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-grid">
        <m-restricao-number label="ID" [restricao]="ds.restricoes.atributo('id')"></m-restricao-number>
        <m-restricao-temporal label="Data Inserção" [restricao]="ds.restricoes.atributo('auditoriaDataInsercao')"></m-restricao-temporal>
        <m-restricao-entidade label="Situação" [restricao]="ds.restricoes.atributo('situacao')" [itens]="getFonteDadosComunicacaoSituacao" itemId="value" itemLabel="label" (click)="ds.pesquisar()"></m-restricao-entidade>
        <m-restricao-string label="Relatório Falha"  [restricao]="ds.restricoes.atributo('relatorio')"></m-restricao-string>
      </div>
      <p-footer>
        <div class="p-fluid p-grid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>
  <div class="p-col-12 p-lg-9">
    <p-card class="fonte-dados-card" header="Lista de Testes de Comunicação">
      <p-table
        [value]="ds.entidades"
        dataKey="id"
        [totalRecords]="ds.total"
        (onLazyLoad)="ds.carregar($event)"
        [lazy]="true"
        [(rows)]="ds.registros"
        [paginator]="true"
        responsive="true"
        sortMode="multiple"
        [sortOrder]="1"
        responsiveLayout="scroll"
        styleClass="tabela-fonte-dados p-datatable-striped"
        emptyMessage="Nenhum registro encontrado">
        <ng-template pTemplate="header">
            <tr>
              <th style="width: 60px"></th>
              <th pSortableColumn="id" style="text-align: center; width: 10%">ID <p-sortIcon field="id"></p-sortIcon></th>
              <th pSortableColumn="auditoriaUsuarioInsercao" style="text-align: center; width: 30%">Usuário Inserção <p-sortIcon field="auditoriaUsuarioInsercao.nome"></p-sortIcon></th>
              <th pSortableColumn="auditoriaDataInsercao" style="text-align: center; width: 30%">Data de Inserção <p-sortIcon field="auditoriaDataInsercao"></p-sortIcon></th>
              <th pSortableColumn="situacao" style="text-align: center; width: 30%">Situação <p-sortIcon field="situacao"></p-sortIcon></th>
              <th pSortableColumn="tempoProcessamento" style="text-align: center; width: 30%">Tempo de Processamento <p-sortIcon field="tempoProcessamento"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entidade let-expanded="expanded">
          <tr>
            <td>
              <button type="button" pButton pRipple [pRowToggler]="entidade" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td class="p-text-center">{{entidade.id}}</td>
            <td class="text-left">{{entidade.auditoriaUsuarioInsercao.nome}}</td>
            <td class="text-left">{{ entidade.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="quebra-texto text-left" [style.color]="setarCor(entidade.situacao | dominio: 'getFonteDadosComunicacaoSituacao')">
                {{entidade.situacao | dominio: 'getFonteDadosComunicacaoSituacao'}}
            </td>
            <td class="text-left">{{entidade.tempoProcessamento}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-entidade>
          <tr>
            <td colspan="5">
              <div class="quebra-texto">
                <span class="p-text-bold">
                  Relatório Falha:
                </span>
                <span [style.color]="setarCor(entidade.situacao | dominio: 'getFonteDadosComunicacaoSituacao')">
                  {{ entidade.relatorio === 'SUCESSO' ? 'Sucesso' : entidade.relatorio}}
                </span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
